import { GetUserQuery } from 'data/__generated__';

import { NotificationPreferencesDetails } from './NotificationPreferencesDetails';

type Props = {
    user: NonNullable<GetUserQuery['userFromAdmin']>;
};

export const NotificationsSection = ({ user }: Props) => {
    return <NotificationPreferencesDetails notificationPreferences={user.notificationPreferences} userId={user._id} />;
};
